import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage, defineMessages, injectIntl } from 'react-intl';
import gql from 'graphql-tag';
import { SplitButton } from 'primereact/splitbutton';

import { withAccount } from '../AccountContext';
import { growlErrors, growlActionSuccess } from '../../utils/NotificationUtil';
import { AssessmentConstants } from '../../shared/Constants';
import { sendRemind } from '../../services/apps/AssessmentServices';
import { intlShape, growlShape } from '../prop-types';
import { withGrowl } from '../GrowlNotifications';

const messages = defineMessages({
  successNoti: {
    id: 'noti.success',
    defaultMessage: 'Success!',
  },
  remind: {
    id: 'assessment.remind.send',
    defaultMessage: 'Send Reminder',
  },
  previewInvite: { id: 'assessment.invite.preview', defaultMessage: 'Preview Invite' },
  previewReminder: { id: 'assessment.remind.preview', defaultMessage: 'Preview Reminder' },
  sendReminder: { id: 'assessment.remind.send', defaultMessage: 'Send Reminder' },
});

const SEND_ASMT_REMIND_MUTATE = gql`
  mutation($input: RemindRespondentTakeAssessmentInput!) {
    reminder: remindRespondentTakeAssessment(input: $input) {
      assessment {
        id
        status
        startedOn
        submittedOn
        createdOn
        updatedOn
        invitedOn
        remindedOn
        expiredOn
      }
    }
  }
`;

const SEND_SURVEY_REMIND_MUTATE = gql`
  mutation($input: RemindRespondentTakeSurveyInput!) {
    reminder: remindRespondentTakeSurvey(input: $input) {
      assessment: surveyRespondent {
        id
        status
        startedOn
        submittedOn
        createdOn
        updatedOn
        invitedOn
        remindedOn
        expiredOn
      }
    }
  }
`;

const SEND_JPS_REMIND_MUTATE = gql`
  mutation($input: RemindRespondentTakeJPSAssessmentInput!) {
    reminder: remindRespondentTakeJPSAssessment(input: $input) {
      assessment: jobProfileSurvey {
        id
        status
        startedOn
        submittedOn
        createdOn
        updatedOn
        invitedOn
        remindedOn
        expiredOn
      }
    }
  }
`;

const getMutateAndInput = (asmt, account) => {
  switch (asmt.instrument) {
    case AssessmentConstants.INSTRUMENT_TYPES.C360: {
      return {
        mutation: SEND_SURVEY_REMIND_MUTATE,
        input: {
          surveyRespondentId: asmt.id,
          accountId: account,
        },
      };
    }
    case AssessmentConstants.INSTRUMENT_TYPES.JPS: {
      return {
        mutation: SEND_JPS_REMIND_MUTATE,
        input: {
          jobProfileSurveyId: asmt.id,
          accountId: account,
        },
      };
    }
    default: {
      return {
        mutation: SEND_ASMT_REMIND_MUTATE,
        input: {
          assessmentId: asmt.id,
          accountId: account,
        },
      };
    }
  }
};

class BoxActionRemind extends Component {
  constructor(props) {
    super(props);
    this.handleSendRemind = this.handleSendRemind.bind(this);
    this.timelineContextMenu = this.timelineContextMenu.bind(this);
  }

  async handleSendRemind(event) {
    event.preventDefault();
    const {
      updateLastAction, growl,
      intl: { formatMessage }, currentAccount, assessment,
    } = this.props;
    const { mutation, input } = getMutateAndInput(assessment, currentAccount);
    try {
      const result = await sendRemind({ mutation, input });
      const { status } = result.reminder.assessment;
      updateLastAction(status);
      growlActionSuccess(growl, formatMessage(messages.successNoti));
    } catch (errors) {
      growlErrors(growl, errors);
    }
  }

  timelineContextMenu() {
    const {
      intl: { formatMessage },
      assessment,
    } = this.props;
    const items = [
      {
        label: formatMessage(messages.previewInvite),
        command: () => {
          window.open(assessment.previewInviteUrl, '_blank');
        },
      },
      {
        label: formatMessage(messages.previewReminder),
        command: () => {
          window.open(assessment.previewReminderUrl, '_blank');
        },
      },
    ];

    return items;
  }

  render() {
    const {
      assessment,
      intl: { formatMessage },
    } = this.props;
    const titleText = formatMessage(messages.remind);
    return (
      <div className="vertList-item vertList-item--block">
        <FormattedMessage id="assessment.remind" defaultMessage="Remind Candidate">
          {text => <p className="vertList-header">{text}</p>}
        </FormattedMessage>

        <div className="vertList-actions">
          <SplitButton
            id={assessment.id}
            label={titleText}
            icon="fa fa-envelope-o"
            model={this.timelineContextMenu()}
            onClick={this.handleSendRemind}
          />
        </div>
      </div>
    );
  }
}

BoxActionRemind.propTypes = {
  intl: intlShape.isRequired,
  assessment: PropTypes.objectOf(PropTypes.any).isRequired,
  currentAccount: PropTypes.string.isRequired,
  updateLastAction: PropTypes.func.isRequired,
  growl: growlShape.isRequired,
};

export default withGrowl(
  injectIntl(withAccount(BoxActionRemind)),
);
